/**
 * Geographic / organisational hierarchy:
 *
 *   Qark (County) → Bashki (Municipality) → Degë (Branch)
 *
 * The third level is a generic "unit". Each municipality declares what its units
 * are called (`UnitType`): party branches by default, or administrative units if the
 * organisation ever mirrors the state subdivisions. Everything is editable by the
 * administrator. See docs/04-geo-hierarchy.md.
 */
export const UnitType = {
    BRANCH: 'BRANCH',
    ADMINISTRATIVE_UNIT: 'ADMINISTRATIVE_UNIT',
};
//# sourceMappingURL=geo.js.map